import { Button, FormLabel, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import CustomTable from "../components/CustomTable";
import FilterBase from "../components/Filter";
import usePagination from "../hooks/Pagination";
import { ManagerTable } from "../interfaces/Manager";
import {
	ArrayContainer,
	Filter,
	Pagination,
	ResponseContainer,
	Sort,
} from "../interfaces/RequestBase";
import { TableTemplate } from "../interfaces/Table";
import {
	GetDirections,
	GetProbations,
	GetRegions,
	GetSpecilizations,
	GetVacancies,
} from "../requester/functions";
import getFilter from "../utilities/filter";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import { useNavigate } from "react-router-dom";

import {
	VacancyFilter,
	VacancySearch,
	VacancyTable,
} from "../interfaces/Vacancy";
import DataSwitch from "../components/DataInputs/DataSwitch";
import Specilization, { Direction } from "./Specilization";
import DataSelect from "../components/DataInputs/DataSelect";
import { City } from "../interfaces/Region";
import DataTextField from "../components/DataInputs/DataTextField";

interface IProps {}

const VacanciesPage = (props: IProps) => {
	const navigate = useNavigate();

	const [vacancy, setVacancy] = useState<VacancyTable[]>([]);
	const [pagination, setPage, setPageSize] = usePagination();
	const [filter, setFilter] = useState<VacancyFilter>({});
	const [search, setSearch] = useState<VacancySearch>({});
	const [sort, setSort] = useState<Sort>({});
	const [totalCount, setTotalCount] = useState<number>(0);

	const [directions, setDirections] = useState<Direction[]>([]);
	const [specilizations, setSpecilizations] = useState<Specilization[]>([]);
	const [cities, setCities] = useState<City[]>([]);

	const rows: TableTemplate = {
		data: [
			{
				title: "Название",
				key: "name",
				sortKey: "name",
			},
			{
				title: "Направление",
				sortKey: "direction.name",
				render: (item: VacancyTable) => item.direction.name,
			},
			{
				title: "Город",
				sortKey: "city.name",
				render: (item: VacancyTable) => item.city.name,
			},
			{
				title: "",
				render: (item: ManagerTable) => (
					<IconButton
						onClick={() => {
							const url = !filter.is_probation
								? `/vacancy/${item.id}`
								: `/probation/${item.id}`;
							navigate(url);
						}}
					>
						<AccountBoxIcon />
					</IconButton>
				),
			},
		],
	};

	useEffect(() => {
		GetDirections({}, (resp) => {
			if (resp.status === "ok" && resp.data) setDirections(resp.data);
		});
		GetSpecilizations({}, (resp) => {
			if (resp.status === "ok" && resp.data) setSpecilizations(resp.data);
		});
		GetRegions({}, (resp) => {
			if (resp.status === "ok" && resp.data) {
				var eventRegions: City[] = [];
				resp.data.forEach((r) => {
					eventRegions.push(...r.cities);
				});
				setCities(eventRegions);
			}
		});
	}, []);

	const getObjectExport = (callback: any) => {
		var req: Filter<VacancyFilter, VacancySearch> = getFilter(
			{ page: 0, size: totalCount } as Pagination,
			filter,
			search,
			sort
		);
		const getObject: any = !filter.is_probation ? GetVacancies : GetProbations;

		getObject(req, (resp: ResponseContainer<ArrayContainer<VacancyTable>>) => {
			if (resp.status === "ok" && resp.data) {
				callback(resp.data.data);
			}
		});
	};

	useEffect(() => {
		var req: Filter<VacancyFilter, VacancySearch> = getFilter(
			pagination as Pagination,
			filter,
			search,
			sort
		);
		const getObject: any = !filter.is_probation ? GetVacancies : GetProbations;

		getObject(req, (resp: ResponseContainer<ArrayContainer<VacancyTable>>) => {
			if (resp.status === "ok" && resp.data) {
				setVacancy(resp.data.data);
				setTotalCount(resp.data?.total_count || 0);
			}
		});
	}, [filter, pagination, search, sort]);

	return (
		<div className="flex flex-col items-end gap-5">
			<div className="flex justify-between w-full">
				<div className="flex gap-4">
					<Button
						variant="contained"
						onClick={() => {
							navigate("/vacancy/create");
						}}
					>
						Создать вакансию
					</Button>
					<Button
						variant="contained"
						onClick={() => {
							navigate("/probation/create");
						}}
					>
						Создать стажировку
					</Button>
				</div>
				<FilterBase setSearch={setSearch} setFilter={setFilter}>
					<DataTextField
						value={search}
						setValue={setSearch}
						keyValue={"name"}
						inputProps={{
							label: "Имя",
						}}
					/>
					<DataSelect
						list={directions}
						value={filter}
						setValue={setFilter}
						keyValue={"direction"}
						label={"Направление"}
					/>
					<DataSelect
						list={specilizations}
						value={filter}
						setValue={setFilter}
						keyValue={"specialization"}
						label={"Специальность"}
					/>
					<DataSelect
						list={cities}
						value={filter}
						setValue={setFilter}
						keyValue={"id_city"}
						label={"Город"}
					/>

					<DataSwitch
						value={filter}
						setValue={setFilter}
						keyValue={"is_delete"}
						label={"Архивные"}
					/>
					<DataSwitch
						value={filter}
						setValue={setFilter}
						keyValue={"remote"}
						label={"Дистанционные"}
					/>
					<div className="flex items-center gap-2">
						<FormLabel color="primary">Вакансии</FormLabel>
						<DataSwitch
							value={filter}
							setValue={setFilter}
							keyValue={"is_probation"}
							label={"Стажировки"}
						/>
					</div>
				</FilterBase>
			</div>
			<CustomTable
				rows={rows}
				data={vacancy}
				allCount={totalCount}
				pagination={pagination as Pagination}
				setPage={setPage as (p: number) => void}
				setPageSize={setPageSize as (p: number) => void}
				sort={sort}
				setSort={setSort}
				onExport={getObjectExport}
			/>
		</div>
	);
};

export default VacanciesPage;
